import type { Journey } from './journeyData';

export const JOURNEYS_BATCH21: Journey[] = [
{
  id: 324,
  slug: 'alaska-wilderness-denali-kenai-glacier-bay',
  title: 'Alaska: Denali, Kenai Fjords & Glacier Bay',
  region: 'North America',
  country: 'USA',
  cities: ['Anchorage', 'Denali', 'Seward', 'Juneau'],
  travelStyle: 'Expedition Journey',
  wayToTravel: 'Expedition Journeys',
  interests: ['Wildlife & Safari', 'Adventure', 'Nature'],
  months: ['June', 'July', 'August'],
  years: ['2025', '2026', '2027'],
  days: 12,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Moderate',
  price: 9800,
  priceLabel: 'From $9,800 pp',
  availability: 'Open',
  shortDescription: 'Alaska\'s last frontier — grizzly bears at Denali, humpback whales in Kenai Fjords, and tidewater glaciers in Glacier Bay.',
  overview: 'Alaska is North America\'s ultimate wilderness destination. Denali National Park protects six million acres of pristine wilderness and North America\'s highest peak. Kenai Fjords offers dramatic fjords, tidewater glaciers, and abundant marine wildlife. Glacier Bay is a UNESCO World Heritage Site of calving glaciers and humpback whales.',
  highlights: [
  'Denali — grizzly bears, wolves, and Dall sheep',
  'Kenai Fjords — orca, humpback whales, and sea otters',
  'Glacier Bay — calving tidewater glaciers',
  'Flightseeing over Denali — North America\'s highest peak',
  'Brown bears fishing for salmon at Brooks Falls',
  'Northern lights (late August)'],

  itinerary: ['Anchorage', 'Denali', 'Seward', 'Juneau', 'Glacier Bay'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Anchorage', description: 'Arrive Anchorage. Alaska Native Heritage Center. Welcome dinner. Day 2: Drive to Denali.', accommodation: 'Hotel Captain Cook', meals: 'Breakfast daily' },
  { day: 'Days 3–5', title: 'Denali National Park', description: 'Three days of wildlife viewing — grizzly bears, moose, wolves, caribou. Flightseeing over Denali summit.', accommodation: 'Camp Denali', meals: 'All meals' },
  { day: 'Days 6–8', title: 'Kenai Fjords', description: 'Day 6: Drive to Seward. Day 7: Full-day fjords cruise — orca, humpbacks, puffins, glaciers. Day 8: Kayaking among icebergs.', accommodation: 'Hotel Seward', meals: 'Breakfast daily' },
  { day: 'Days 9–12', title: 'Glacier Bay', description: 'Day 9: Fly to Juneau. Day 10: Glacier Bay cruise — calving glaciers, humpback whales. Day 11: Mendenhall Glacier hike. Day 12: Depart Juneau.', accommodation: 'Goldbelt Hotel Juneau', meals: 'Breakfast daily' }],

  accommodation: 'Hotel Captain Cook (Anchorage); Camp Denali; Hotel Seward; Goldbelt Hotel Juneau.',
  included: ['All accommodation', 'Daily breakfast', 'All meals at Denali', 'Expert naturalist guide', 'All park fees', 'Fjords cruise', 'Flightseeing', 'All transfers'],
  excluded: ['International flights to Anchorage', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Anchorage; private coach; light aircraft; cruise vessel.',
  meals: 'All meals at Denali; breakfast daily elsewhere.',
  packing: ['Waterproof jacket', 'Warm layers', 'Hiking boots', 'Binoculars', 'Camera', 'Insect repellent', 'Sunscreen'],
  visa: 'US visa or ESTA required for most nationalities.',
  weather: 'June–August: long daylight hours, 10–20°C. Late August: possible northern lights.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What wildlife can we expect at Denali?', answer: 'Denali is home to grizzly bears, wolves, moose, caribou, Dall sheep, and over 160 bird species. Sightings are excellent in summer.' },
  { question: 'Is the flightseeing safe?', answer: 'Yes — we use licensed operators with excellent safety records. Weather permitting, flightseeing over Denali is one of Alaska\'s most spectacular experiences.' }],

  seo: {
    title: 'Alaska Denali Kenai Fjords Glacier Bay | Worldway × A&K',
    description: 'Alaska wilderness — Denali grizzlies, Kenai Fjords whales, and Glacier Bay glaciers with Worldway × A&K.',
    keywords: ['Alaska tour', 'Denali', 'Kenai Fjords', 'Glacier Bay', 'grizzly bears', 'humpback whales'],
    ogImage: "https://images.unsplash.com/photo-1659551077776-34344ab9cefa"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80'],

  relatedJourneys: ['canada-rockies-banff-jasper-yoho-private', 'greenland-arctic-expedition-ilulissat-scoresby'],
  aiIndex: { tags: ['Alaska', 'Denali', 'Kenai Fjords', 'Glacier Bay', 'grizzly bears', 'humpback whales', 'glaciers'], searchable: true }
},
{
  id: 325,
  slug: 'brazil-amazon-pantanal-iguazu-rio-carnival',
  title: 'Brazil: Amazon, Pantanal, Iguazú & Rio',
  region: 'Latin America',
  country: 'Brazil',
  cities: ['Manaus', 'Cuiabá', 'Foz do Iguaçu', 'Rio de Janeiro'],
  travelStyle: 'Wildlife Journey',
  wayToTravel: 'Wildlife Journeys',
  interests: ['Wildlife & Safari', 'Nature', 'Culture & Heritage'],
  months: ['July', 'August', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 14,
  groupSize: 'Small Group — maximum 10 guests',
  activityLevel: 'Moderate',
  price: 8900,
  priceLabel: 'From $8,900 pp',
  availability: 'Open',
  shortDescription: 'Brazil\'s greatest natural wonders — the Amazon rainforest, Pantanal jaguars, Iguazú Falls, and Rio de Janeiro.',
  overview: 'Brazil is South America\'s most biodiverse country. The Amazon is the world\'s largest rainforest. The Pantanal is the world\'s largest tropical wetland and the best place on Earth to see jaguars. Iguazú Falls is one of the world\'s greatest waterfalls. Rio de Janeiro is one of the world\'s most beautiful cities.',
  highlights: [
  'Amazon — pink river dolphins, piranhas, and jungle canopy walks',
  'Pantanal — jaguar spotting by boat',
  'Iguazú Falls — the world\'s widest waterfall system',
  'Rio de Janeiro — Christ the Redeemer and Copacabana',
  'Caiman — caimans, capybaras, and giant otters',
  'Manaus — the Teatro Amazonas opera house'],

  itinerary: ['Manaus', 'Amazon', 'Cuiabá', 'Pantanal', 'Iguazú', 'Rio de Janeiro'],
  itineraryDays: [
  { day: 'Days 1–4', title: 'Amazon', description: 'Day 1: Arrive Manaus. Teatro Amazonas. Day 2–4: Amazon jungle lodge — canopy walks, night safaris, pink dolphins, piranha fishing.', accommodation: 'Anavilhanas Jungle Lodge', meals: 'All meals' },
  { day: 'Days 5–8', title: 'Pantanal', description: 'Day 5: Fly to Cuiabá. Transfer to Pantanal. Days 6–8: Jaguar spotting by boat, caiman, giant otters, capybaras.', accommodation: 'Caiman Ecological Refuge', meals: 'All meals' },
  { day: 'Days 9–10', title: 'Iguazú Falls', description: 'Day 9: Fly to Foz do Iguaçu. Brazilian side of the falls. Day 10: Argentine side — Devil\'s Throat walkway.', accommodation: 'Belmond Hotel das Cataratas', meals: 'Breakfast daily' },
  { day: 'Days 11–14', title: 'Rio de Janeiro', description: 'Day 11: Fly to Rio. Copacabana. Day 12: Christ the Redeemer, Sugarloaf. Day 13: Santa Teresa, Lapa. Day 14: Depart.', accommodation: 'Belmond Copacabana Palace', meals: 'Breakfast daily' }],

  accommodation: 'Anavilhanas Jungle Lodge (Amazon); Caiman Ecological Refuge (Pantanal); Belmond Hotel das Cataratas (Iguazú); Belmond Copacabana Palace (Rio).',
  included: ['All accommodation', 'All meals in Amazon and Pantanal', 'Daily breakfast', 'Expert naturalist guide', 'All park fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Manaus', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Manaus; domestic flights; private boat; private 4WD.',
  meals: 'All meals in Amazon and Pantanal; breakfast daily elsewhere.',
  packing: ['Lightweight clothing', 'Waterproof jacket', 'Insect repellent (essential)', 'Sunscreen', 'Camera', 'Binoculars', 'Swimwear'],
  visa: 'Brazil visa required for some nationalities. Check requirements.',
  weather: 'July–October: dry season — best for Pantanal jaguars and Amazon wildlife.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What are the chances of seeing a jaguar?', answer: 'The Pantanal has the highest jaguar density in the world. During the dry season (July–October), sighting rates exceed 90% on a 3-night stay.' },
  { question: 'Is the Amazon safe?', answer: 'Yes — our jungle lodges are safe and comfortable. Expert guides accompany all activities. Vaccinations (yellow fever) are recommended.' }],

  seo: {
    title: 'Brazil Amazon Pantanal Iguazú Rio | Worldway × A&K',
    description: 'Brazil\'s greatest wonders — Amazon, Pantanal jaguars, Iguazú Falls, and Rio with Worldway × A&K.',
    keywords: ['Brazil tour', 'Amazon', 'Pantanal', 'jaguar', 'Iguazú Falls', 'Rio de Janeiro'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1af4f5566-1778336389595.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['peru-amazon-manu-tambopata-wildlife', 'colombia-cartagena-coffee-region-amazon'],
  aiIndex: { tags: ['Brazil', 'Amazon', 'Pantanal', 'jaguar', 'Iguazú', 'Rio de Janeiro', 'wildlife'], searchable: true }
},
{
  id: 326,
  slug: 'saudi-arabia-al-ula-hegra-diriyah-red-sea',
  title: 'Saudi Arabia: AlUla, Hegra, Diriyah & Red Sea',
  region: 'Middle East',
  country: 'Saudi Arabia',
  cities: ['Riyadh', 'AlUla', 'Hegra', 'Diriyah', 'NEOM'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'History', 'Adventure'],
  months: ['October', 'November', 'December', 'January', 'February', 'March'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 8500,
  priceLabel: 'From $8,500 pp',
  availability: 'Open',
  shortDescription: 'Saudi Arabia\'s extraordinary new tourism frontier — Hegra\'s Nabataean tombs, AlUla\'s sandstone canyons, Diriyah\'s UNESCO old city, and the Red Sea.',
  overview: 'Saudi Arabia is one of the world\'s most exciting new tourism destinations. AlUla is a vast open-air museum of ancient civilisations. Hegra (Mada\'in Saleh) is Saudi Arabia\'s first UNESCO World Heritage Site — a Nabataean city of rock-cut tombs rivalling Petra. Diriyah is the birthplace of the Saudi state and a UNESCO World Heritage Site. The Red Sea offers world-class diving.',
  highlights: [
  'Hegra — Nabataean rock-cut tombs rivalling Petra',
  'AlUla — sandstone canyons and ancient rock art',
  'Diriyah — UNESCO birthplace of the Saudi state',
  'Elephant Rock — AlUla\'s iconic natural arch',
  'Red Sea diving — pristine coral reefs',
  'Riyadh — the National Museum and Kingdom Tower'],

  itinerary: ['Riyadh', 'AlUla', 'Hegra', 'Diriyah', 'Red Sea'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Riyadh', description: 'Day 1: Arrive Riyadh. National Museum. Welcome dinner. Day 2: Diriyah UNESCO site — At-Turaif District.', accommodation: 'Four Seasons Hotel Riyadh', meals: 'Breakfast daily' },
  { day: 'Days 3–7', title: 'AlUla & Hegra', description: 'Day 3: Fly to AlUla. Elephant Rock. Day 4: Hegra — Nabataean tombs. Day 5: Dadan and Jabal Ikmah rock art. Day 6: AlUla old town. Day 7: Stargazing in the desert.', accommodation: 'Banyan Tree AlUla', meals: 'Breakfast daily' },
  { day: 'Days 8–10', title: 'Red Sea', description: 'Day 8: Fly to NEOM/Tabuk. Red Sea resort. Day 9: Diving or snorkelling — pristine coral reefs. Day 10: Depart.', accommodation: 'Shebara Resort', meals: 'Breakfast daily' }],

  accommodation: 'Four Seasons Hotel Riyadh; Banyan Tree AlUla; Shebara Resort (Red Sea).',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'All park and site fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Riyadh', 'Travel insurance', 'Gratuities', 'Personal expenses', 'Diving equipment'],
  transport: 'International flight to Riyadh; domestic flights; private 4WD.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Modest clothing (shoulders and knees covered)', 'Sunscreen', 'Sunglasses', 'Hat', 'Camera', 'Swimwear for Red Sea'],
  visa: 'Saudi Arabia tourist e-visa available for most nationalities online.',
  weather: 'October–March: 15–25°C — ideal. April–September: very hot (40°C+).',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Is Saudi Arabia safe for tourists?', answer: 'Yes — Saudi Arabia has invested heavily in tourism infrastructure and safety. Our expert guides ensure a comfortable and culturally respectful experience.' },
  { question: 'What should women wear?', answer: 'Women no longer need to wear an abaya in Saudi Arabia, but modest clothing (covering shoulders and knees) is recommended and respectful.' }],

  seo: {
    title: 'Saudi Arabia AlUla Hegra Diriyah Red Sea | Worldway × A&K',
    description: 'Saudi Arabia\'s new tourism frontier — Hegra, AlUla, Diriyah, and Red Sea diving with Worldway × A&K.',
    keywords: ['Saudi Arabia tour', 'AlUla', 'Hegra', 'Nabataean', 'Diriyah', 'Red Sea'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_180add312-1772191573340.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1586724237569-f3d0c1dee8c6?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['oman-muscat-wahiba-sands-nizwa-fjords', 'jordan-petra-wadi-rum-dead-sea-aqaba'],
  aiIndex: { tags: ['Saudi Arabia', 'AlUla', 'Hegra', 'Nabataean', 'Diriyah', 'Red Sea', 'UNESCO'], searchable: true }
},
{
  id: 327,
  slug: 'vietnam-north-south-halong-hoi-an-mekong',
  title: 'Vietnam: North to South — Hanoi, Ha Long, Hội An & Mekong',
  region: 'Asia',
  country: 'Vietnam',
  cities: ['Hanoi', 'Ha Long Bay', 'Hội An', 'Ho Chi Minh City', 'Mekong Delta'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'Culinary', 'Nature'],
  months: ['February', 'March', 'April', 'October', 'November', 'December'],
  years: ['2025', '2026', '2027'],
  days: 14,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 5800,
  priceLabel: 'From $5,800 pp',
  availability: 'Open',
  shortDescription: 'Vietnam\'s greatest journey — Hanoi\'s Old Quarter, Ha Long Bay\'s limestone karsts, Hội An\'s lantern-lit streets, and the Mekong Delta.',
  overview: 'Vietnam is one of Southeast Asia\'s most captivating destinations — a country of extraordinary diversity, from the limestone karsts of Ha Long Bay to the ancient trading port of Hội An, the imperial city of Huế, and the vibrant Mekong Delta. Vietnamese cuisine is among the world\'s finest.',
  highlights: [
  'Ha Long Bay — overnight cruise among limestone karsts',
  'Hội An — lantern-lit Ancient Town at dusk',
  'Hanoi — Old Quarter, Hoan Kiem Lake, street food',
  'Huế — Imperial Citadel and royal tombs',
  'Mekong Delta — floating markets and river life',
  'Cooking class — Vietnamese cuisine masterclass'],

  itinerary: ['Hanoi', 'Ha Long Bay', 'Huế', 'Hội An', 'Ho Chi Minh City', 'Mekong Delta'],
  itineraryDays: [
  { day: 'Days 1–3', title: 'Hanoi', description: 'Day 1: Arrive Hanoi. Old Quarter walking tour. Day 2: Ho Chi Minh Mausoleum, Temple of Literature, street food tour. Day 3: Day trip to Ninh Binh — Tràng An boat trip.', accommodation: 'Sofitel Legend Metropole Hanoi', meals: 'Breakfast daily' },
  { day: 'Days 4–5', title: 'Ha Long Bay', description: 'Day 4: Board luxury junk. Kayaking through caves. Sunset cocktails. Day 5: Morning tai chi on deck. Return to Hanoi. Fly to Huế.', accommodation: 'Heritage Line Ginger Cruise', meals: 'All meals on board' },
  { day: 'Days 6–7', title: 'Huế', description: 'Day 6: Imperial Citadel, Forbidden Purple City. Day 7: Royal tombs by dragon boat. Drive to Hội An via Hải Vân Pass.', accommodation: 'Azerai La Résidence Huế', meals: 'Breakfast daily' },
  { day: 'Days 8–10', title: 'Hội An', description: 'Day 8: Ancient Town lantern walk. Day 9: Cooking class — market to table. Day 10: My Son Cham ruins. Fly to Ho Chi Minh City.', accommodation: 'Four Seasons The Nam Hai', meals: 'Breakfast daily' },
  { day: 'Days 11–14', title: 'Ho Chi Minh City & Mekong', description: 'Day 11: War Remnants Museum, Reunification Palace. Day 12–13: Mekong Delta — floating markets, river villages. Day 14: Depart.', accommodation: 'Park Hyatt Saigon', meals: 'Breakfast daily' }],

  accommodation: 'Sofitel Legend Metropole Hanoi; Heritage Line Ginger Cruise; Azerai La Résidence Huế; Four Seasons The Nam Hai (Hội An); Park Hyatt Saigon.',
  included: ['All accommodation', 'Daily breakfast', 'All meals on Ha Long cruise', 'Expert guide', 'All entrance fees', 'Cooking class', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Hanoi', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Hanoi; domestic flights; luxury junk; private coach.',
  meals: 'All meals on Ha Long cruise; breakfast daily elsewhere.',
  packing: ['Lightweight clothing', 'Modest clothing for temples', 'Sunscreen', 'Insect repellent', 'Camera', 'Comfortable walking shoes'],
  visa: 'Vietnam e-visa available online for most nationalities (90 days).',
  weather: 'Feb–Apr and Oct–Dec: best weather. Central Vietnam (Hội An) best Nov–Feb.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What is the best time to visit Ha Long Bay?', answer: 'October to April offers the best weather — clear skies and calm seas. May to September can bring rain and occasional typhoons.' },
  { question: 'Is Vietnamese food spicy?', answer: 'Vietnamese cuisine is generally mild with fresh herbs and balanced flavours. Chilli is served on the side, so you control the heat.' }],

  seo: {
    title: 'Vietnam Hanoi Ha Long Hội An Mekong | Worldway × A&K',
    description: 'Vietnam north to south — Ha Long Bay, Hội An, Huế, and the Mekong Delta with Worldway × A&K.',
    keywords: ['Vietnam tour', 'Ha Long Bay', 'Hội An', 'Hanoi', 'Mekong Delta', 'cultural journey'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1fae61202-1777212029338.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1528360983277-13d401cdc186?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['cambodia-angkor-phnom-penh-siem-reap-mekong', 'laos-luang-prabang-vang-vieng-4000-islands'],
  aiIndex: { tags: ['Vietnam', 'Ha Long Bay', 'Hội An', 'Hanoi', 'Mekong Delta', 'Huế', 'cultural'], searchable: true }
},
{
  id: 328,
  slug: 'peru-sacred-valley-machu-picchu-lake-titicaca',
  title: 'Peru: Sacred Valley, Machu Picchu & Lake Titicaca',
  region: 'Latin America',
  country: 'Peru',
  cities: ['Lima', 'Cusco', 'Sacred Valley', 'Machu Picchu', 'Puno'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'History', 'Adventure'],
  months: ['April', 'May', 'June', 'July', 'August', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 12,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Moderate',
  price: 7200,
  priceLabel: 'From $7,200 pp',
  availability: 'Open',
  shortDescription: 'Peru\'s greatest Inca journey — Cusco, the Sacred Valley, Machu Picchu by private train, and Lake Titicaca\'s floating islands.',
  overview: 'Peru is home to one of the world\'s greatest ancient civilisations. The Inca Empire built extraordinary cities, temples, and agricultural terraces across the Andes. Machu Picchu is the world\'s most iconic archaeological site. The Sacred Valley is dotted with Inca ruins and traditional markets. Lake Titicaca is the world\'s highest navigable lake.',
  highlights: [
  'Machu Picchu — sunrise over the Lost City of the Incas',
  'Sacred Valley — Pisac market and Ollantaytambo fortress',
  'Cusco — Qorikancha Temple and San Blas neighbourhood',
  'Lake Titicaca — Uros floating reed islands',
  'Hiram Bingham train — luxury rail to Machu Picchu',
  'Taquile Island — traditional Andean weaving'],

  itinerary: ['Lima', 'Cusco', 'Sacred Valley', 'Machu Picchu', 'Puno'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Lima', description: 'Day 1: Arrive Lima. Miraflores and Barranco. Welcome dinner at Central. Day 2: Larco Museum. Fly to Cusco.', accommodation: 'Belmond Miraflores Park', meals: 'Breakfast daily' },
  { day: 'Days 3–4', title: 'Cusco', description: 'Day 3: Acclimatise. Qorikancha, San Blas, Plaza de Armas. Day 4: Sacsayhuamán, Qenqo, Tambomachay.', accommodation: 'Belmond Palacio Nazarenas', meals: 'Breakfast daily' },
  { day: 'Days 5–7', title: 'Sacred Valley', description: 'Day 5: Pisac market and ruins. Day 6: Ollantaytambo fortress. Day 7: Moray and Maras salt pans.', accommodation: 'Explora Valle Sagrado', meals: 'All meals' },
  { day: 'Days 8–9', title: 'Machu Picchu', description: 'Day 8: Hiram Bingham train. Afternoon at Machu Picchu. Day 9: Sunrise at Machu Picchu. Sun Gate hike. Return to Cusco.', accommodation: 'Belmond Sanctuary Lodge', meals: 'All meals' },
  { day: 'Days 10–12', title: 'Lake Titicaca', description: 'Day 10: Fly to Puno. Uros floating islands. Day 11: Taquile Island — traditional weaving. Day 12: Fly Lima. Depart.', accommodation: 'Titilaka Lodge', meals: 'All meals' }],

  accommodation: 'Belmond Miraflores Park (Lima); Belmond Palacio Nazarenas (Cusco); Explora Valle Sagrado; Belmond Sanctuary Lodge (Machu Picchu); Titilaka Lodge (Titicaca).',
  included: ['All accommodation', 'All meals at lodges', 'Daily breakfast', 'Expert guide', 'Hiram Bingham train', 'All entrance fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Lima', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Lima; domestic flights; Hiram Bingham luxury train; private coach.',
  meals: 'All meals at lodges; breakfast daily elsewhere.',
  packing: ['Warm layers (Andes nights are cold)', 'Waterproof jacket', 'Hiking boots', 'Sunscreen', 'Altitude sickness medication', 'Camera'],
  visa: 'Peru visa-free for most nationalities (90 days).',
  weather: 'April–October: dry season — best for Machu Picchu and Titicaca.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'How do I acclimatise to the altitude?', answer: 'Cusco is at 3,400m. We build in acclimatisation days and recommend arriving a day early. Coca tea, hydration, and rest help. Altitude medication is available.' },
  { question: 'Can I hike the Inca Trail?', answer: 'The classic 4-day Inca Trail can be added as an optional extension. Permits must be booked months in advance.' }],

  seo: {
    title: 'Peru Sacred Valley Machu Picchu Lake Titicaca | Worldway × A&K',
    description: 'Peru\'s Inca journey — Sacred Valley, Machu Picchu, and Lake Titicaca with Worldway × A&K.',
    keywords: ['Peru tour', 'Machu Picchu', 'Sacred Valley', 'Lake Titicaca', 'Cusco', 'Inca'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1bfd9a434-1772251057406.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1526392060635-9d6019884377?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['peru-amazon-manu-tambopata-wildlife', 'bolivia-salt-flats-uyuni-potosi-la-paz'],
  aiIndex: { tags: ['Peru', 'Machu Picchu', 'Sacred Valley', 'Lake Titicaca', 'Cusco', 'Inca', 'Andes'], searchable: true }
},
{
  id: 329,
  slug: 'india-golden-triangle-varanasi-khajuraho',
  title: 'India: Golden Triangle, Varanasi & Khajuraho',
  region: 'Asia',
  country: 'India',
  cities: ['Delhi', 'Agra', 'Jaipur', 'Varanasi', 'Khajuraho'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'History', 'Spiritual'],
  months: ['October', 'November', 'December', 'January', 'February', 'March'],
  years: ['2025', '2026', '2027'],
  days: 14,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 6800,
  priceLabel: 'From $6,800 pp',
  availability: 'Open',
  shortDescription: 'India\'s most iconic journey — the Taj Mahal, Jaipur\'s Pink City, Varanasi\'s sacred ghats, and Khajuraho\'s erotic temples.',
  overview: 'India\'s Golden Triangle — Delhi, Agra, and Jaipur — is the country\'s most visited circuit, combining Mughal grandeur, Rajput palaces, and ancient temples. Varanasi is one of the world\'s oldest continuously inhabited cities and Hinduism\'s holiest site. Khajuraho\'s medieval temples are UNESCO World Heritage Sites of extraordinary sculptural artistry.',
  highlights: [
  'Taj Mahal — sunrise at the world\'s greatest monument to love',
  'Varanasi — Ganga Aarti ceremony at dawn',
  'Jaipur — Amber Fort and City Palace',
  'Khajuraho — UNESCO medieval temple sculptures',
  'Delhi — Humayun\'s Tomb and Qutb Minar',
  'Fatehpur Sikri — Akbar\'s abandoned Mughal capital'],

  itinerary: ['Delhi', 'Agra', 'Fatehpur Sikri', 'Jaipur', 'Khajuraho', 'Varanasi'],
  itineraryDays: [
  { day: 'Days 1–3', title: 'Delhi', description: 'Day 1: Arrive Delhi. Old Delhi — Jama Masjid, spice market. Day 2: New Delhi — India Gate, Humayun\'s Tomb, Qutb Minar. Day 3: Drive to Agra.', accommodation: 'The Imperial New Delhi', meals: 'Breakfast daily' },
  { day: 'Days 4–5', title: 'Agra', description: 'Day 4: Taj Mahal at sunrise and sunset. Agra Fort. Day 5: Fatehpur Sikri. Drive to Jaipur.', accommodation: 'Oberoi Amarvilas', meals: 'Breakfast daily' },
  { day: 'Days 6–8', title: 'Jaipur', description: 'Day 6: Amber Fort by elephant. Day 7: City Palace, Jantar Mantar, Hawa Mahal. Day 8: Block printing workshop. Fly to Khajuraho.', accommodation: 'Rambagh Palace', meals: 'Breakfast daily' },
  { day: 'Days 9–10', title: 'Khajuraho', description: 'Day 9: Western Group temples — UNESCO sculptures. Day 10: Eastern Group temples. Fly to Varanasi.', accommodation: 'Taj Nadesar Palace', meals: 'Breakfast daily' },
  { day: 'Days 11–14', title: 'Varanasi', description: 'Day 11: Ganga Aarti at Dashashwamedh Ghat. Day 12: Dawn boat on the Ganges — ghats and cremation ceremonies. Day 13: Sarnath — where Buddha preached. Day 14: Fly Delhi. Depart.', accommodation: 'Brijrama Palace', meals: 'Breakfast daily' }],

  accommodation: 'The Imperial New Delhi; Oberoi Amarvilas (Agra); Rambagh Palace (Jaipur); Taj Nadesar Palace (Khajuraho); Brijrama Palace (Varanasi).',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'All entrance fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Delhi', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Delhi; domestic flights; private air-conditioned coach.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Modest clothing for temples', 'Comfortable walking shoes', 'Sunscreen', 'Insect repellent', 'Camera', 'Hand sanitiser'],
  visa: 'India e-visa available online for most nationalities.',
  weather: 'October–March: 15–25°C — ideal. April–June: very hot. July–September: monsoon.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Is the Taj Mahal as impressive in person?', answer: 'The Taj Mahal exceeds all expectations. Sunrise is the most magical time — the marble glows pink and the crowds are smaller.' },
  { question: 'Is Varanasi suitable for sensitive travellers?', answer: 'Varanasi is intense and deeply spiritual. Open-air cremations are visible at Manikarnika Ghat. Our guides provide respectful context and support.' }],

  seo: {
    title: 'India Golden Triangle Varanasi Khajuraho | Worldway × A&K',
    description: 'India\'s iconic journey — Taj Mahal, Jaipur, Varanasi, and Khajuraho with Worldway × A&K.',
    keywords: ['India tour', 'Golden Triangle', 'Taj Mahal', 'Varanasi', 'Khajuraho', 'Jaipur'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1de7bd3b5-1785153227180.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['india-kerala-backwaters-spice-coast-wildlife', 'india-rajasthan-private-palaces-desert-safari'],
  aiIndex: { tags: ['India', 'Golden Triangle', 'Taj Mahal', 'Varanasi', 'Khajuraho', 'Jaipur', 'cultural'], searchable: true }
},
{
  id: 330,
  slug: 'kenya-laikipia-samburu-lewa-private-conservancy',
  title: 'Kenya: Laikipia, Samburu & Lewa Private Conservancy',
  region: 'Africa',
  country: 'Kenya',
  cities: ['Nairobi', 'Laikipia', 'Samburu', 'Lewa'],
  travelStyle: 'Wildlife Journey',
  wayToTravel: 'Wildlife Journeys',
  interests: ['Wildlife & Safari', 'Conservation', 'Adventure'],
  months: ['January', 'February', 'June', 'July', 'August', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Private — 2 to 8 guests',
  activityLevel: 'Easy',
  price: 12500,
  priceLabel: 'From $12,500 pp',
  availability: 'Open',
  shortDescription: 'Kenya\'s most exclusive private conservancies — Laikipia\'s rhino sanctuary, Samburu\'s unique northern species, and Lewa\'s black rhino.',
  overview: 'Northern Kenya\'s private conservancies offer a completely different safari experience from the Masai Mara — vast landscapes, fewer visitors, and unique northern species. Laikipia Plateau is Kenya\'s most important rhino sanctuary. Samburu National Reserve is home to species found nowhere else in Kenya. Lewa Wildlife Conservancy is a UNESCO World Heritage Site and home to the world\'s largest black rhino population.',
  highlights: [
  'Laikipia — white and black rhino on foot',
  'Samburu — Grevy\'s zebra, reticulated giraffe, Beisa oryx',
  'Lewa — black rhino tracking on horseback',
  'Night game drives — aardvark, porcupine, and serval',
  'Camel trekking across the Laikipia Plateau',
  'Conservation briefings with anti-poaching teams'],

  itinerary: ['Nairobi', 'Laikipia', 'Samburu', 'Lewa'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Nairobi', description: 'Day 1: Arrive Nairobi. Giraffe Centre. Welcome dinner. Day 2: Fly to Laikipia.', accommodation: 'Hemingways Nairobi', meals: 'Breakfast daily' },
  { day: 'Days 3–5', title: 'Laikipia Plateau', description: 'Day 3: Arrive Ol Pejeta. Rhino tracking on foot. Day 4: Camel trekking. Night game drive. Day 5: Chimpanzee sanctuary. Fly to Samburu.', accommodation: 'Ol Pejeta Bush Camp', meals: 'All meals' },
  { day: 'Days 6–8', title: 'Samburu', description: 'Day 6: Arrive Samburu. Afternoon game drive — Grevy\'s zebra, reticulated giraffe. Day 7: Full day game drives. Day 8: Morning drive. Fly to Lewa.', accommodation: 'Sasaab Lodge', meals: 'All meals' },
  { day: 'Days 9–10', title: 'Lewa', description: 'Day 9: Arrive Lewa. Black rhino tracking on horseback. Day 10: Morning walk. Fly Nairobi. Depart.', accommodation: 'Lewa House', meals: 'All meals' }],

  accommodation: 'Hemingways Nairobi; Ol Pejeta Bush Camp; Sasaab Lodge (Samburu); Lewa House.',
  included: ['All accommodation', 'All meals', 'Expert guide', 'All game drives', 'Camel trekking', 'Horseback rhino tracking', 'All park fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Nairobi', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Nairobi; light aircraft between camps; private 4WD.',
  meals: 'All meals throughout.',
  packing: ['Neutral safari clothing', 'Warm layers for early mornings', 'Binoculars', 'Camera', 'Sunscreen', 'Insect repellent', 'Soft-sided luggage'],
  visa: 'Kenya e-visa available online.',
  weather: 'Jan–Feb and Jun–Oct: dry season — best game viewing.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What makes Laikipia different from the Masai Mara?', answer: 'Laikipia is a private conservancy with far fewer visitors, offering exclusive game drives, walking safaris, and camel trekking. It is Kenya\'s most important rhino sanctuary.' },
  { question: 'Is horseback rhino tracking safe?', answer: 'Yes — horses are calm around wildlife and allow you to get closer than vehicles. Expert guides accompany all rides.' }],

  seo: {
    title: 'Kenya Laikipia Samburu Lewa Private Conservancy | Worldway × A&K',
    description: 'Kenya\'s exclusive private conservancies — Laikipia rhinos, Samburu, and Lewa with Worldway × A&K.',
    keywords: ['Kenya safari', 'Laikipia', 'Samburu', 'Lewa', 'rhino', 'private conservancy'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_13ef6fa61-1783637049051.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80',
  'https://images.unsplash.com/photo-1549366021-9f761d450615?w=800&q=80'],

  relatedJourneys: ['kenya-masai-mara-amboseli-laikipia-private', 'tanzania-serengeti-ngorongoro-zanzibar-beach'],
  aiIndex: { tags: ['Kenya', 'Laikipia', 'Samburu', 'Lewa', 'rhino', 'private conservancy', 'conservation'], searchable: true }
},
{
  id: 331,
  slug: 'japan-tokyo-kyoto-hiroshima-hakone-nara',
  title: 'Japan: Tokyo, Kyoto, Hiroshima, Hakone & Nara',
  region: 'Asia',
  country: 'Japan',
  cities: ['Tokyo', 'Hakone', 'Kyoto', 'Nara', 'Hiroshima', 'Miyajima'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'Culinary', 'History'],
  months: ['March', 'April', 'May', 'October', 'November'],
  years: ['2025', '2026', '2027'],
  days: 14,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 9200,
  priceLabel: 'From $9,200 pp',
  availability: 'Open',
  shortDescription: 'Japan\'s essential journey — Tokyo\'s neon streets, Hakone\'s Mount Fuji views, Kyoto\'s geisha districts, Nara\'s sacred deer, and Hiroshima\'s peace memorial.',
  overview: 'Japan is one of the world\'s most extraordinary travel destinations — a country where ancient traditions coexist with cutting-edge modernity. Tokyo is the world\'s most dynamic city. Kyoto preserves Japan\'s cultural soul with 17 UNESCO World Heritage Sites. Hiroshima\'s Peace Memorial is one of the world\'s most moving sites. Nara\'s sacred deer roam freely among ancient temples.',
  highlights: [
  'Tokyo — Shibuya crossing, Tsukiji market, teamLab digital art',
  'Mount Fuji — views from Hakone',
  'Kyoto — Fushimi Inari torii gates at dawn',
  'Nara — feeding sacred deer at Tōdai-ji',
  'Hiroshima Peace Memorial — deeply moving',
  'Miyajima — floating torii gate at high tide'],

  itinerary: ['Tokyo', 'Hakone', 'Kyoto', 'Nara', 'Hiroshima', 'Miyajima'],
  itineraryDays: [
  { day: 'Days 1–4', title: 'Tokyo', description: 'Day 1: Arrive Tokyo. Shinjuku. Welcome dinner. Day 2: Tsukiji, teamLab, Shibuya. Day 3: Asakusa, Ueno, Akihabara. Day 4: Harajuku, Omotesandō, Meiji Shrine.', accommodation: 'Aman Tokyo', meals: 'Breakfast daily' },
  { day: 'Days 5–6', title: 'Hakone', description: 'Day 5: Bullet train to Hakone. Mount Fuji views. Ryokan check-in. Day 6: Open-air museum. Return to Tokyo. Bullet train to Kyoto.', accommodation: 'Gora Kadan Ryokan', meals: 'All meals' },
  { day: 'Days 7–10', title: 'Kyoto', description: 'Day 7: Fushimi Inari at dawn. Nishiki Market. Day 8: Arashiyama bamboo grove, Kinkaku-ji. Day 9: Gion geisha district. Tea ceremony. Day 10: Philosopher\'s Path. Nijo Castle.', accommodation: 'Aman Kyoto', meals: 'Breakfast daily' },
  { day: 'Days 11–12', title: 'Nara & Osaka', description: 'Day 11: Nara — Tōdai-ji, sacred deer. Day 12: Osaka — Dotonbori street food. Bullet train to Hiroshima.', accommodation: 'The St. Regis Osaka', meals: 'Breakfast daily' },
  { day: 'Days 13–14', title: 'Hiroshima & Miyajima', description: 'Day 13: Peace Memorial Museum. Miyajima — floating torii. Day 14: Fly Tokyo. Depart.', accommodation: 'Sheraton Grand Hiroshima', meals: 'Breakfast daily' }],

  accommodation: 'Aman Tokyo; Gora Kadan Ryokan (Hakone); Aman Kyoto; The St. Regis Osaka; Sheraton Grand Hiroshima.',
  included: ['All accommodation', 'Daily breakfast', 'All meals at ryokan', 'Expert guide', 'Bullet train passes', 'All entrance fees', 'Tea ceremony', 'All transfers'],
  excluded: ['International flights to Tokyo', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Tokyo; Shinkansen bullet trains; private coach.',
  meals: 'All meals at ryokan; breakfast daily elsewhere.',
  packing: ['Comfortable walking shoes', 'Modest clothing for temples', 'Layers for variable weather', 'Camera', 'IC card for transport'],
  visa: 'Japan visa-free for most nationalities (90 days).',
  weather: 'March–May: cherry blossom season. October–November: autumn foliage.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What is the best time for cherry blossoms?', answer: 'Late March to early April — exact dates vary by year. We monitor forecasts and adjust itineraries to maximise blossom viewing.' },
  { question: 'Is Japan expensive?', answer: 'Japan can be expensive, but our itinerary is carefully curated to offer exceptional value. Street food and local restaurants offer outstanding quality at reasonable prices.' }],

  seo: {
    title: 'Japan Tokyo Kyoto Hiroshima Hakone Nara | Worldway × A&K',
    description: 'Japan\'s essential journey — Tokyo, Kyoto, Hiroshima, and Nara with Worldway × A&K.',
    keywords: ['Japan tour', 'Tokyo', 'Kyoto', 'Hiroshima', 'Hakone', 'Nara', 'cherry blossom'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_122e38d75-1769712184416.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['japan-hokkaido-winter-snow-monkeys-powder', 'south-korea-seoul-jeju-gyeongju-cultural'],
  aiIndex: { tags: ['Japan', 'Tokyo', 'Kyoto', 'Hiroshima', 'Hakone', 'Nara', 'cherry blossom', 'cultural'], searchable: true }
},
{
  id: 332,
  slug: 'morocco-imperial-cities-sahara-atlas-fes',
  title: 'Morocco: Imperial Cities, Sahara & Atlas Mountains',
  region: 'Africa',
  country: 'Morocco',
  cities: ['Casablanca', 'Fès', 'Meknès', 'Marrakech', 'Sahara Desert', 'Atlas Mountains'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'Adventure', 'Culinary'],
  months: ['March', 'April', 'May', 'September', 'October', 'November'],
  years: ['2025', '2026', '2027'],
  days: 12,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 5200,
  priceLabel: 'From $5,200 pp',
  availability: 'Open',
  shortDescription: 'Morocco\'s imperial cities, Sahara dunes, and Atlas Mountains — Fès medina, Marrakech souks, and a camel trek to a desert camp.',
  overview: 'Morocco is one of the world\'s most sensory travel destinations — a country of ancient medinas, imperial palaces, Saharan dunes, and Berber mountain villages. The four imperial cities — Fès, Meknès, Marrakech, and Rabat — each have a distinct character. The Sahara Desert offers one of the world\'s great camel trekking experiences.',
  highlights: [
  'Fès medina — the world\'s largest car-free urban area',
  'Sahara Desert — camel trek and overnight desert camp',
  'Marrakech — Djemaa el-Fna square at night',
  'Atlas Mountains — Berber villages and mountain passes',
  'Meknès — Bab Mansour gate and Roman Volubilis',
  'Moroccan cooking class — tagine and couscous'],

  itinerary: ['Casablanca', 'Rabat', 'Meknès', 'Fès', 'Sahara', 'Marrakech'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Casablanca & Rabat', description: 'Day 1: Arrive Casablanca. Hassan II Mosque. Drive to Rabat. Day 2: Kasbah of the Udayas, Chellah ruins. Drive to Meknès.', accommodation: 'Sofitel Rabat Jardin des Roses', meals: 'Breakfast daily' },
  { day: 'Days 3–4', title: 'Meknès & Fès', description: 'Day 3: Bab Mansour, Moulay Ismail Mausoleum. Volubilis Roman ruins. Day 4: Arrive Fès. Medina orientation walk.', accommodation: 'Riad Fès', meals: 'Breakfast daily' },
  { day: 'Days 5–6', title: 'Fès', description: 'Day 5: Chouara tanneries, Al-Qarawiyyin mosque, Bou Inania Madrasa. Day 6: Cooking class. Pottery workshop. Drive south.', accommodation: 'Riad Fès', meals: 'Breakfast daily' },
  { day: 'Days 7–9', title: 'Sahara Desert', description: 'Day 7: Drive via Ifrane and Midelt. Day 8: Camel trek into the Erg Chebbi dunes. Overnight luxury desert camp. Day 9: Sunrise over the dunes. Drive to Marrakech via Draa Valley.', accommodation: 'Luxury Desert Camp', meals: 'All meals in desert' },
  { day: 'Days 10–12', title: 'Marrakech', description: 'Day 10: Arrive Marrakech. Djemaa el-Fna. Day 11: Bahia Palace, Saadian Tombs, souks. Day 12: Majorelle Garden. Depart.', accommodation: 'La Mamounia', meals: 'Breakfast daily' }],

  accommodation: 'Sofitel Rabat; Riad Fès; Luxury Desert Camp (Merzouga); La Mamounia (Marrakech).',
  included: ['All accommodation', 'Daily breakfast', 'All meals in desert', 'Expert guide', 'Camel trek', 'Cooking class', 'All entrance fees', 'All transfers'],
  excluded: ['International flights to Casablanca', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Casablanca; private air-conditioned coach.',
  meals: 'All meals in desert; breakfast daily elsewhere.',
  packing: ['Lightweight clothing', 'Warm layers for desert nights', 'Modest clothing for medinas', 'Sunscreen', 'Camera', 'Comfortable walking shoes'],
  visa: 'Morocco visa-free for most nationalities (90 days).',
  weather: 'March–May and September–November: 20–28°C — ideal.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Is the Sahara camel trek difficult?', answer: 'The camel trek is 1–2 hours each way — suitable for all fitness levels. The luxury desert camp has comfortable beds, hot showers, and gourmet dining.' },
  { question: 'Is Morocco safe for solo travellers?', answer: 'Morocco is generally safe. Our expert guides accompany all activities and navigate the medinas with confidence.' }],

  seo: {
    title: 'Morocco Imperial Cities Sahara Atlas Mountains | Worldway × A&K',
    description: 'Morocco\'s imperial cities, Sahara dunes, and Atlas Mountains with Worldway × A&K.',
    keywords: ['Morocco tour', 'Fès', 'Marrakech', 'Sahara Desert', 'Atlas Mountains', 'imperial cities'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1e0024784-1778708141780.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1539020140153-e479b8c22e70?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['egypt-nile-cruise-luxor-aswan-abu-simbel', 'jordan-petra-wadi-rum-dead-sea-aqaba'],
  aiIndex: { tags: ['Morocco', 'Fès', 'Marrakech', 'Sahara', 'Atlas Mountains', 'imperial cities', 'cultural'], searchable: true }
},
{
  id: 333,
  slug: 'iceland-ring-road-northern-lights-glaciers-geysers',
  title: 'Iceland: Ring Road, Northern Lights & Glaciers',
  region: 'Europe',
  country: 'Iceland',
  cities: ['Reykjavik', 'Golden Circle', 'South Coast', 'Jökulsárlón', 'Akureyri'],
  travelStyle: 'Adventure Journey',
  wayToTravel: 'Adventure Journeys',
  interests: ['Adventure', 'Nature', 'Wildlife & Safari'],
  months: ['September', 'October', 'November', 'February', 'March'],
  years: ['2025', '2026', '2027'],
  days: 10,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Moderate',
  price: 7800,
  priceLabel: 'From $7,800 pp',
  availability: 'Open',
  shortDescription: 'Iceland\'s Ring Road — northern lights, glacier hikes, geyser eruptions, whale watching, and the midnight sun.',
  overview: 'Iceland is one of the world\'s most dramatic landscapes — a land of fire and ice where volcanoes, glaciers, geysers, and waterfalls coexist. The Ring Road circles the entire island, passing through every type of Icelandic landscape. The northern lights (September–March) are one of nature\'s greatest spectacles.',
  highlights: [
  'Northern lights — dancing aurora borealis',
  'Jökulsárlón glacier lagoon — icebergs and seals',
  'Geysir — erupting every 5–10 minutes',
  'Skógafoss and Seljalandsfoss waterfalls',
  'Glacier hiking on Vatnajökull',
  'Whale watching from Húsavík'],

  itinerary: ['Reykjavik', 'Golden Circle', 'South Coast', 'Jökulsárlón', 'East Fjords', 'Akureyri'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Reykjavik', description: 'Day 1: Arrive Reykjavik. Hallgrímskirkja. Blue Lagoon. Day 2: Golden Circle — Þingvellir, Geysir, Gullfoss.', accommodation: 'Hotel Borg', meals: 'Breakfast daily' },
  { day: 'Days 3–4', title: 'South Coast', description: 'Day 3: Seljalandsfoss, Skógafoss, black sand beach at Reynisfjara. Day 4: Glacier hike on Vatnajökull.', accommodation: 'Fosshotel Glacier Lagoon', meals: 'Breakfast daily' },
  { day: 'Days 5–6', title: 'Jökulsárlón & East Fjords', description: 'Day 5: Jökulsárlón glacier lagoon — boat among icebergs. Diamond Beach. Day 6: East Fjords — dramatic coastal scenery.', accommodation: 'Hótel Aldan', meals: 'Breakfast daily' },
  { day: 'Days 7–10', title: 'North Iceland', description: 'Day 7: Mývatn — volcanic craters, hot springs. Day 8: Húsavík whale watching. Day 9: Akureyri — Iceland\'s second city. Northern lights hunt. Day 10: Fly Reykjavik. Depart.', accommodation: 'Deplar Farm', meals: 'All meals' }],

  accommodation: 'Hotel Borg (Reykjavik); Fosshotel Glacier Lagoon; Hótel Aldan (East Fjords); Deplar Farm (North Iceland).',
  included: ['All accommodation', 'Daily breakfast', 'All meals at Deplar Farm', 'Expert guide', 'Glacier hike equipment', 'Whale watching', 'Blue Lagoon', 'All transfers'],
  excluded: ['International flights to Reykjavik', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Reykjavik; private 4WD.',
  meals: 'All meals at Deplar Farm; breakfast daily elsewhere.',
  packing: ['Waterproof jacket and trousers', 'Warm layers', 'Hiking boots', 'Gloves and hat', 'Camera', 'Swimwear for hot springs'],
  visa: 'Iceland is Schengen — EU/EEA visa-free. Others check requirements.',
  weather: 'Sep–Mar: northern lights possible. Jun–Aug: midnight sun. Winter: 0–5°C.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Are northern lights guaranteed?', answer: 'Northern lights depend on solar activity and clear skies. We maximise chances with expert guides and flexible scheduling, but cannot guarantee sightings.' },
  { question: 'Is Iceland suitable in winter?', answer: 'Yes — winter offers the best northern lights and a magical snowy landscape. Roads are well-maintained and our vehicles are equipped for all conditions.' }],

  seo: {
    title: 'Iceland Ring Road Northern Lights Glaciers | Worldway × A&K',
    description: 'Iceland Ring Road — northern lights, glaciers, geysers, and whale watching with Worldway × A&K.',
    keywords: ['Iceland tour', 'Ring Road', 'northern lights', 'glaciers', 'Jökulsárlón', 'geysers'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1f750efa5-1767387045919.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['norway-fjords-lofoten-svalbard-northern-lights', 'greenland-arctic-expedition-ilulissat-scoresby'],
  aiIndex: { tags: ['Iceland', 'Ring Road', 'northern lights', 'glaciers', 'Jökulsárlón', 'geysers', 'whale watching'], searchable: true }
},
{
  id: 334,
  slug: 'south-africa-kruger-private-cape-winelands-garden-route',
  title: 'South Africa: Kruger Private, Cape Winelands & Garden Route',
  region: 'Africa',
  country: 'South Africa',
  cities: ['Johannesburg', 'Kruger', 'Cape Town', 'Stellenbosch', 'Garden Route'],
  travelStyle: 'Wildlife Journey',
  wayToTravel: 'Wildlife Journeys',
  interests: ['Wildlife & Safari', 'Culinary', 'Nature'],
  months: ['May', 'June', 'July', 'August', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 14,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 10500,
  priceLabel: 'From $10,500 pp',
  availability: 'Open',
  shortDescription: 'South Africa\'s greatest journey — Big Five safari in Kruger\'s private reserves, Cape Town\'s Table Mountain, Stellenbosch wine estates, and the Garden Route.',
  overview: 'South Africa offers one of the world\'s most diverse travel experiences — from the Big Five safari in Kruger\'s private reserves to Cape Town\'s iconic Table Mountain, the world-class Stellenbosch wine estates, and the spectacular Garden Route. This journey combines the best of South Africa\'s wildlife, culture, cuisine, and landscapes.',
  highlights: [
  'Sabi Sands — legendary leopard sightings',
  'Table Mountain — cable car and sunset views',
  'Stellenbosch — wine tasting at top estates',
  'Cape of Good Hope — where two oceans meet',
  'Tsitsikamma — bungee jumping and forest walks',
  'Knysna Lagoon — oysters and sunset cruise'],

  itinerary: ['Johannesburg', 'Kruger', 'Cape Town', 'Stellenbosch', 'Garden Route'],
  itineraryDays: [
  { day: 'Days 1–2', title: 'Johannesburg', description: 'Day 1: Arrive Johannesburg. Apartheid Museum. Welcome dinner. Day 2: Soweto township tour. Fly to Kruger.', accommodation: 'Saxon Hotel Villas & Spa', meals: 'Breakfast daily' },
  { day: 'Days 3–6', title: 'Kruger Private Reserves', description: 'Day 3: Arrive Sabi Sands. Afternoon game drive. Day 4–5: Morning and evening game drives — Big Five. Day 6: Morning walk. Fly Cape Town.', accommodation: 'Londolozi Private Granite Suites', meals: 'All meals' },
  { day: 'Days 7–9', title: 'Cape Town', description: 'Day 7: Table Mountain cable car. Waterfront. Day 8: Cape Peninsula — Cape of Good Hope, Boulders penguins. Day 9: Robben Island. V&A Waterfront dinner.', accommodation: 'The Silo Hotel', meals: 'Breakfast daily' },
  { day: 'Days 10–11', title: 'Stellenbosch Winelands', description: 'Day 10: Wine tasting at Tokara, Delaire Graff, Waterford. Day 11: Franschhoek — wine tram. Drive to Garden Route.', accommodation: 'Delaire Graff Estate', meals: 'Breakfast daily' },
  { day: 'Days 12–14', title: 'Garden Route', description: 'Day 12: Knysna Lagoon cruise. Oyster tasting. Day 13: Tsitsikamma forest walk. Storms River. Day 14: Fly Cape Town. Depart.', accommodation: 'Pezula Resort Hotel & Spa', meals: 'Breakfast daily' }],

  accommodation: 'Saxon Hotel (Johannesburg); Londolozi Private Granite Suites (Sabi Sands); The Silo Hotel (Cape Town); Delaire Graff Estate (Stellenbosch); Pezula Resort (Garden Route).',
  included: ['All accommodation', 'All meals on safari', 'Daily breakfast', 'Expert guide', 'All game drives', 'All park fees', 'All internal flights', 'All transfers'],
  excluded: ['International flights to Johannesburg', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Johannesburg; domestic flights; private coach.',
  meals: 'All meals on safari; breakfast daily elsewhere.',
  packing: ['Neutral safari clothing', 'Smart casual for Cape Town', 'Sunscreen', 'Camera', 'Binoculars', 'Comfortable walking shoes'],
  visa: 'South Africa visa-free for most nationalities (90 days).',
  weather: 'May–October: dry season — best for safari. Cape Town: best November–April.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'What is the difference between Kruger and Sabi Sands?', answer: 'Sabi Sands is a private reserve adjacent to Kruger with no fences between them. It has far fewer visitors, exclusive lodges, and the best leopard sightings in Africa.' },
  { question: 'Can I combine this with a beach extension?', answer: 'Yes — Mozambique, Mauritius, or the Seychelles make excellent beach extensions after the Garden Route.' }],

  seo: {
    title: 'South Africa Kruger Cape Town Winelands Garden Route | Worldway × A&K',
    description: 'South Africa\'s greatest journey — Kruger safari, Cape Town, Stellenbosch, and Garden Route with Worldway × A&K.',
    keywords: ['South Africa tour', 'Kruger', 'Cape Town', 'Stellenbosch', 'Garden Route', 'Big Five'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1ea31f15a-1784752719874.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80',
  'https://images.unsplash.com/photo-1549366021-9f761d450615?w=800&q=80'],

  relatedJourneys: ['botswana-okavango-delta-chobe-moremi-private', 'zimbabwe-victoria-falls-hwange-mana-pools'],
  aiIndex: { tags: ['South Africa', 'Kruger', 'Cape Town', 'Stellenbosch', 'Garden Route', 'Big Five', 'safari'], searchable: true }
},
{
  id: 335,
  slug: 'greece-athens-santorini-mykonos-crete-rhodes',
  title: 'Greece: Athens, Santorini, Mykonos, Crete & Rhodes',
  region: 'Europe',
  country: 'Greece',
  cities: ['Athens', 'Santorini', 'Mykonos', 'Crete', 'Rhodes'],
  travelStyle: 'Cultural Journey',
  wayToTravel: 'Cultural Journeys',
  interests: ['Culture & Heritage', 'Culinary', 'History'],
  months: ['April', 'May', 'June', 'September', 'October'],
  years: ['2025', '2026', '2027'],
  days: 14,
  groupSize: 'Small Group — maximum 12 guests',
  activityLevel: 'Easy',
  price: 7500,
  priceLabel: 'From $7,500 pp',
  availability: 'Open',
  shortDescription: 'Greece\'s island odyssey — Athens\' Acropolis, Santorini\'s caldera sunsets, Mykonos\' windmills, Crete\'s Minoan palaces, and Rhodes\' medieval old town.',
  overview: 'Greece is one of the world\'s most captivating destinations — the birthplace of democracy, philosophy, and Western civilisation. Athens\' Acropolis is one of the world\'s greatest ancient monuments. The Greek islands offer extraordinary diversity — from Santorini\'s volcanic caldera to Crete\'s Minoan ruins and Rhodes\' UNESCO medieval old town.',
  highlights: [
  'Acropolis — Parthenon at sunrise',
  'Santorini — caldera sunset from Oia',
  'Crete — Knossos Minoan palace',
  'Rhodes — UNESCO medieval old town',
  'Mykonos — windmills and Little Venice',
  'Greek cooking class — moussaka and baklava'],

  itinerary: ['Athens', 'Santorini', 'Mykonos', 'Crete', 'Rhodes'],
  itineraryDays: [
  { day: 'Days 1–3', title: 'Athens', description: 'Day 1: Arrive Athens. Plaka neighbourhood. Welcome dinner. Day 2: Acropolis at sunrise, National Archaeological Museum. Day 3: Cape Sounion. Fly to Santorini.', accommodation: 'Hotel Grande Bretagne', meals: 'Breakfast daily' },
  { day: 'Days 4–6', title: 'Santorini', description: 'Day 4: Arrive Santorini. Oia village. Caldera sunset. Day 5: Akrotiri Minoan ruins. Wine tasting. Day 6: Boat trip around the caldera. Ferry to Mykonos.', accommodation: 'Canaves Oia Suites', meals: 'Breakfast daily' },
  { day: 'Days 7–8', title: 'Mykonos', description: 'Day 7: Windmills, Little Venice, Chora. Day 8: Delos island — ancient sanctuary. Ferry to Crete.', accommodation: 'Mykonos Grand Hotel', meals: 'Breakfast daily' },
  { day: 'Days 9–11', title: 'Crete', description: 'Day 9: Arrive Heraklion. Knossos palace. Day 10: Samariá Gorge hike. Day 11: Cooking class. Fly to Rhodes.', accommodation: 'Blue Palace Elounda', meals: 'Breakfast daily' },
  { day: 'Days 12–14', title: 'Rhodes', description: 'Day 12: Medieval old town — Street of the Knights. Day 13: Lindos acropolis. Day 14: Fly Athens. Depart.', accommodation: 'Lindos Blu', meals: 'Breakfast daily' }],

  accommodation: 'Hotel Grande Bretagne (Athens); Canaves Oia Suites (Santorini); Mykonos Grand Hotel; Blue Palace Elounda (Crete); Lindos Blu (Rhodes).',
  included: ['All accommodation', 'Daily breakfast', 'Expert guide', 'All entrance fees', 'Cooking class', 'Delos boat trip', 'All internal flights and ferries', 'All transfers'],
  excluded: ['International flights to Athens', 'Travel insurance', 'Gratuities', 'Personal expenses'],
  transport: 'International flight to Athens; domestic flights; ferries; private coach.',
  meals: 'Daily breakfast; select dinners.',
  packing: ['Lightweight summer clothing', 'Comfortable walking shoes', 'Swimwear', 'Sunscreen', 'Camera', 'Modest clothing for churches'],
  visa: 'Greece is Schengen — EU/EEA visa-free. Others check requirements.',
  weather: 'April–June and September–October: 20–28°C — ideal. July–August: very hot.',
  bookingConditions: '30% deposit to confirm. Full payment 90 days before departure.',
  cancellationPolicy: '90+ days: deposit forfeited. 60–89 days: 50%. Under 60 days: 100%.',
  faqs: [
  { question: 'Is Santorini worth the hype?', answer: 'Absolutely — Santorini\'s caldera views are among the world\'s most spectacular. We recommend visiting in April–May or September–October to avoid peak summer crowds.' },
  { question: 'Can we swim at the beaches?', answer: 'Yes — Greece has some of Europe\'s finest beaches. We build in beach time at each island.' }],

  seo: {
    title: 'Greece Athens Santorini Mykonos Crete Rhodes | Worldway × A&K',
    description: 'Greece island odyssey — Athens, Santorini, Mykonos, Crete, and Rhodes with Worldway × A&K.',
    keywords: ['Greece tour', 'Santorini', 'Mykonos', 'Athens', 'Crete', 'Rhodes', 'Greek islands'],
    ogImage: "https://img.rocket.new/generatedImages/rocket_gen_img_15cd24034-1785755486636.png"
  },
  heroImage: "https://img.rocket.new/generatedImages/rocket_gen_img_1d99f36af-1764866840786.png",
  gallery: [
  'https://images.unsplash.com/photo-1533105079780-92b9be482077?w=800&q=80',
  'https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80',
  'https://images.unsplash.com/photo-1504173010664-32509107de5f?w=800&q=80'],

  relatedJourneys: ['italy-amalfi-coast-sicily-rome-florence', 'croatia-dalmatian-coast-dubrovnik-split-hvar'],
  aiIndex: { tags: ['Greece', 'Santorini', 'Mykonos', 'Athens', 'Crete', 'Rhodes', 'Greek islands', 'cultural'], searchable: true }
}];